import CryptoJS from 'crypto-js';

var genKey = function () {
	let random = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let str = "";
	for (let i = 0; i < 16; i++) {
		str  = str + random.charAt(Math.random() * random.length)
	}
	return str;
}

//加密
var encrypt = function (plaintext,keystr) {
	let key = keystr+'001';
	if (plaintext instanceof Object) {
		//JSON.stringify
		plaintext = JSON.stringify(plaintext)
	}
	let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), CryptoJS.enc.Utf8.parse(key), {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
	return encrypted.toString();
}

//解密
var decrypt = function (ciphertext,keystr) {
	let key = keystr+'001';
	let decrypt = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(key), {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
	let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString();
	if(decString.charAt(0) === "{" || decString.charAt(0) === "[" ){
		//JSON.parse
		decString = JSON.parse(decString);
	}
	return decString;
}

//解密
var Decrypt = function (ciphertext,keystr) {
	let key = '0'+keystr+'01';
	let decrypt = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(key), {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
	let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString();
	if(decString.charAt(0) === "{" || decString.charAt(0) === "[" ){
		//JSON.parse
		decString = JSON.parse(decString);
	}
	return decString;
}


export {
    encrypt,
    decrypt,
    Decrypt,
}


// WEBPACK FOOTER //
// ./src/components/common/common.js